import { NgModule } from '@angular/core';
import { AutoScrollTextComponent } from './auto-scroll-text.component';

@NgModule({
    declarations: [
        AutoScrollTextComponent
    ],
    imports: [],
    exports: [
        AutoScrollTextComponent
    ]
})
export class NcAutoScrollTextModule { }